var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{attrs:{"variant":_vm.badgeProperties.variant,"aria-label":_vm.badgeProperties.text}},[_c('gl-icon',{attrs:{"name":_vm.badgeProperties.icon}}),_vm._v(" "),_c('span',{staticClass:"gl-display-none gl-sm-display-block gl-ml-2"},[_vm._v(_vm._s(_vm.badgeProperties.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }